import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39c10f51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "auth-page__wrapper" }
const _hoisted_3 = { class: "auth-page__card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "auth-page__title" }, " Sign in to Daily Constancy ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-page__subtitle" }, " Use your email and password to access your account ", -1))
const _hoisted_6 = { class: "auth-page__form-actions" }
const _hoisted_7 = { class: "auth-page__footer" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-page__footer-text" }, " Don't have an account? ", -1))

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

import DSTextField from '@/design-system/DSTextField.vue';
import DSButton from '@/design-system/DSButton.vue';

import { api } from '@/libs/api';
import { jwt } from '@/static/storage-keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'DCLogin',
  setup(__props) {

const router = useRouter();
const $q = useQuasar();

const email = ref('');
const password = ref('');
const remember_me = ref(false);
const request_pending = ref(false);

const handleLogin = async() => {
  const body = {
    email: email.value,
    password: password.value,
  };

  request_pending.value = true;
  const { token } = await api.post('/login', body);
  request_pending.value = false;

  if (token) {
    $q.notify({
      progress: true,
      type: 'positive',
      message: 'Logado com sucesso.',
      icon: 'done',
      position: 'top-right',
    });

    $q.cookies.set(jwt, token, { expires: '7d' });
    return router.push({ path: '/' });
  }

  return $q.notify({
    progress: true,
    type: 'negative',
    message: 'Não foi possível realizar o login.',
    icon: 'error_outline',
    position: 'top-right',
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: handleLogin,
          class: "auth-page__form"
        }, [
          _createVNode(DSTextField, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            label: "Email",
            placeholder: "Enter your email",
            icon: "email",
            type: "email",
            autocomplete: "email",
            "aria-label": "Email"
          }, null, 8, ["modelValue"]),
          _createVNode(DSTextField, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            label: "Password",
            placeholder: "Enter your password",
            icon: "lock",
            type: "password",
            autocomplete: "current-password",
            onKeyup: _withKeys(handleLogin, ["enter"]),
            "aria-label": "Password"
          }, null, 8, ["modelValue", "onKeyup"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_checkbox, {
              modelValue: remember_me.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((remember_me).value = $event)),
              label: "Remember me",
              color: "primary",
              dense: "",
              class: "auth-page__checkbox"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_router_link, {
              to: "/forgot-password",
              class: "auth-page__forgot"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Forgot password? ")
              ]),
              _: 1
            })
          ]),
          _createVNode(DSButton, {
            type: "submit",
            label: "Sign in",
            icon: "login",
            loading: request_pending.value,
            variant: "primary",
            class: "auth-page__submit"
          }, null, 8, ["loading"])
        ], 32),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_router_link, {
            to: { name: 'register' },
            class: "auth-page__link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign up ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})